@if (canSeeLeaflogix) {
  <button mat-menu-item
    title="Manually sync and update all information associated with Dutchie batches"
    [disabled]="disabled"
    (click)="sync()"
    >
    <mat-icon>sync</mat-icon>
    <span>Sync Dutchie Batches</span>
  </button>
}